<template>
  <div class="my_house">
    <head-top head-title="我的房屋" goBack="true"></head-top>
    <div>
      <div class="house_list" v-for="(item,index) in lists" @click="toResult(item.id,item.status)" :key="index">
        <div class="list_div">
          <div class="list_div_left">
            <img src="./images/Hdefault.png" alt="">
          </div>
          <div class="list_div_right">
            <h1>{{item.title}}</h1>
            <h2>{{item.fang}}</h2>
            <p>认证结果：<span>{{item.progress}}</span></p>
          </div>
          <div class="list_div_icon">
            <span v-if="item.status === 1">编辑</span>
            <img src="../home/images/fanhui1@2x.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="home_addBtn">
      <!--<button @click="toHouseConfirm()">-->
      <button class="go_ident" @click="goIdent()">
        <span>业主变更</span>
      </button>
      <button class="again_btn" @click="rematch()">
        <span>重新匹配</span>
      </button>
    </div>
  </div>
</template>
<style lang="scss">
  /*@import "../../common/sass/index.scss";*/

  .my_house {
    width: 100%;
    padding-top: 40px;
    .house_list {
      .list_div {
        border-bottom: 1px solid #d9d9d9;
        width: 100%;
        padding-bottom: 10px;
        height: 70px;
        .list_div_left {
          float: left;
          display: flex;
          width: 70px;
          height: 70px;
          img{
            width: 100%;
          }
        }
        .list_div_right {
          padding-left: 10px;
          float: left;
          h1 {
            font-size: 15px;
            color: #292929;
            font-weight: normal;
            margin-top: 5px
          }
          h2 {
            font-size: 13px;
            font-weight: normal;
            line-height: 36px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #666;
            width: 220px;
          }
          p {
            font-size: 13px;
            font-weight: normal;
            span{
              color: #0f7dd5;
            }
          }
        }
        .list_div_icon{
          float: right;
          padding-right: 10px;
          padding-top: 30px;
          display: inline-flex;
          align-items: center;
          span{
            color: #0f7dd5;
            padding-right: 6px;
            font-size: 14px;
          }
          img{
            width: 8px;
            height: 15px;
          }
        }
      }
    }
    .home_addBtn {
      width: 100%;
      text-align: center;
      margin-top: 20px;
      padding-bottom: 20px;
      display: inline-flex;
      align-items: center;
      justify-content: space-around;
      .go_ident{
        width: 45%;
        background: #cecece;
        outline: none;
        span {
          line-height: 44px;
          font-size: 15px;
          color: #fff;
        }
      }
      .again_btn {
        width: 45%;
        background: #0078de;
        outline: none;
        span {
          line-height: 44px;
          font-size: 15px;
          color: #fff;
        }
      }
    }
  }
</style>
<script>
  import headTop from '../header/Header.vue'
  import {
          loadPhoneName
          } from '../../common/js/cache.js'
  import {Toast} from 'mint-ui'
  import {getDatas, rematch} from '../../api/my.js'

  export default {
    name: 'MyHouse',
    data () {
      return {
        lists: []
      }
    },
    components: {
      headTop
    },
    created () {
      this._getDatas()
    },
    methods: {
      _getDatas () {
        // const url = commonUrl.apihost + 'index.php/home/house_Auth/getMyHouse?openid=oHVoI1YSCHpddlq7bEXa62gcdbTA'
        getDatas().then(res => {
          if (res.code === 200) {
            this.lists = res.data
          }
        })
      },
      // 重新匹配
      rematch() {
        rematch(loadPhoneName().name, loadPhoneName().phone).then(res => {
          // console.log(res)
          if (res.code === 200) {
            this.lists = res.data
            Toast({
              message: '匹配成功',
              position: 'middle',
              duration: 1500
            })
          }
          if (res.code === 400) {
            Toast({
              message: res.error,
              position: 'middle',
              duration: 1500
            })
          }
        })
      },
      toHouseConfirm () {
        if ((loadPhoneName().phone === '0' || loadPhoneName().phone === '') || loadPhoneName().name === '') {
          this.$router.push('/EditData1')
          Toast({
            message: '请先编辑资料',
            position: 'middle',
            duration: 1500
          })
        } else {
          this.$router.push('/my/HouseConfirm')
        }
      },
      toResult (id, status) {
        this.$router.push('/my/Result/' + id + '/' + status)
      },
      // 去到业主变更
      goIdent () {
        window.location.href = '/my/Ident'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/my/MyHouse.vue